export const getChartPlaceholder = (isAllHidden: boolean, containerWidth: number): string => {
  if (isAllHidden) {
    return "Click a series above to show it";
  }
  if (containerWidth === 0) {
    return "";
  }
  return "No data available for selected period";
};
